import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core';
import { SportsService } from 'src/app/services/sports.service';
import { Subscription } from 'rxjs';
import { ISport } from 'src/app/models/sportHierarchy/sport';
import { IRegion } from 'src/app/models/sportHierarchy/region';
import { UtilityService } from 'src/app/services/util/utility.service';
import { PageType, ComponentName, EventMappingType, ErrorLevel, TimeFilter, SiteViewConfiguration, PlatformHeadrId, SpecialOfferType } from 'src/app/models/enums';
import { ActivatedRoute } from '@angular/router';
import { ICompetition } from 'src/app/models/sportHierarchy/competition.iterface';
import { QueryParamsService } from 'src/app/services/http/queryParams.service';
import { StorageService } from 'src/app/services/util/storage.service';
import { LoaderService } from 'src/app/services/loader.service';
import { CacheService } from 'src/app/services/cache.service';
import { ISportRegionCompetitionSelection } from 'src/app/models/sportHierarchy/sportRegionCompetitionSelection.interface';
import { ICustomNotification } from 'src/app/models/notification/customNotification.interface';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { NotificationService } from 'src/app/services/notification.service';
import { CacheChangesService } from 'src/app/services/cacheChanges.service';
import { ISrcSelectionIds } from 'src/app/models/util/srcSelectionIds.interface';
import { EventsService } from 'src/app/services/events.service';
import { IOddSheets } from 'src/app/models/oddSheets/oddSheets.interface';
import { DeployParams } from 'src/app/deployParams';
import { ConstantValues } from 'src/app/models/util/constantValues';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { RegionNameMap } from 'src/app/models/util/regionNameMap';
import { LocaleHelper } from 'src/locale/LocaleHelper';
import { environment } from 'src/environments/environment';
declare let $: any;

@Component({
  selector: 'app-sportstree',
  templateUrl: './sportstree.component.html',
  styleUrls: ['./sportstree.component.less']
})
export class SportstreeComponent implements OnInit, OnChanges, OnDestroy {
  sports: ISport[] = [];
  private subscription: Subscription = new Subscription();
  isMobileView: boolean;
  pageType: PageType = PageType.Prematch;
  pageTypeEnum = PageType;
  isLive = false;
  private language: string;
  languageForBetradar: string;
  eventMappingTypeEnum = EventMappingType;
  private dateToStringFormat: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit' };
  srcSelection: ISportRegionCompetitionSelection;
  srcSelectionIds: ISrcSelectionIds;
  initialLoad = true;
  public showNoEventsForSportMessage = false;
  public oddSheets: IOddSheets = null;
  public downloadListUrl: string = environment.baseURL + 'downloadList';
  public viewConfigurations = ViewConfigurations;
  favoriteCompetitions: ICompetition[] = [];
  public favoriteCompetitionsHaveOnlineEvents = false;
  favoriteLeaguesIsExpanded = false;
  // myLeaguesTitle: string;
  regionNameMap = RegionNameMap;

  dynamicTranslations = DynamicTranslations;

  betRadarCompanyName: string;

  // eventOfDayShortcut = 'Eod';
  // superBetShortcut = 'SB';


  constructor(
    public sportsService: SportsService,
    protected utilityService: UtilityService,
    protected queryParams: QueryParamsService,
    protected route: ActivatedRoute,
    protected loaderService: LoaderService,
    protected cacheService: CacheService,
    protected cacheChanges: CacheChangesService,
    protected storage: StorageService,
    protected eventsService: EventsService,
    protected notificationService: NotificationService) {
    this.isMobileView = utilityService.mobileView;


    this.language = storage.language;
    // this.languageForBetradar = this.language === 'sr' ? 'srl' : this.language;
    // this.languageForBetradar = this.language === 'en-US' ? 'en' : this.language;

    this.languageForBetradar = LocaleHelper.languageForBetradar[this.language];

    if (environment.viewConfiguration === SiteViewConfiguration.NIGERIA){
      this.betRadarCompanyName = 'winnersgoldenbet';
    } else {
      this.betRadarCompanyName = 'admiralbeteeuof';
    }


    this.subscription.add(sportsService.timeFilterChanged$.subscribe((x) => {
      this.pageType = this.queryParams.pageType;
      if (this.queryParams.pageType === PageType.Results) {
        return;
      }
      this.getSportsTree();
    }));

    this.subscription.add(this.cacheService.sportTreeElementsWithAddedRemovedEventsChanged$.subscribe(s => {
      this.getSportsTree();
    }));

    this.subscription.add(this.cacheService.sportTreeChanged$.subscribe(() => this.getSportsTree()));

    this.subscription.add(this.sportsService.deselectSportsNotification$.subscribe(() => this.deselectSports()));

    if (this.isMobileView) {
      this.subscription.add(this.sportsService.srcSelectionChanged$.subscribe(s => {
        this.srcSelection = this.sportsService.sportRegionCompetitionSelection;
        // this.srcSelection = {
        //   sport: this.sportsService.sportRegionCompetitionSelection.sport,
        //   region: this.sportsService.sportRegionCompetitionSelection.region,
        //   competition: this.sportsService.sportRegionCompetitionSelection.competition,
        // };

        this.filterSelections();
      }));
    }
  }

  selectMostPopularOrNextMatches(isMostPopular: boolean) {
    if (isMostPopular && this.queryParams.pageType === PageType.MostPopular) {
      return;
    }

    if (!isMostPopular && this.queryParams.pageType === PageType.Soon) {
      return;
    }

    if (isMostPopular) {
      this.queryParams.pageType = PageType.MostPopular;
    } else {
      this.queryParams.pageType = PageType.Soon;
    }
    this.eventsService.expandEvent(null);
    this.deselectSports();
    this.sportsService.setSelectionsForSport(null, false);
  }

  filterSelections() {
    // if (this.sportsService.sportRegionCompetitionSelection.sport.isSelected && this.sportsService.sportRegionCompetitionSelection.sport.eventsCount < 1) {
    //   const sportToSelect = this.sports.find(s => s.eventsCount > 0);
    //   if (sportToSelect) {
    //     this.selectSport(sportToSelect);
    //   }
    //   return;
    // }

    // if (this.sportsService.sportRegionCompetitionSelection.region.isSelected && this.sportsService.sportRegionCompetitionSelection.region.eventsCount < 1) {
    //   const regionToSelect = this.sportsService.sportRegionCompetitionSelection.sport.regions.find(r => r.eventsCount > 0);
    //   if (regionToSelect) {
    //     this.selectRegion(regionToSelect, this.sportsService.sportRegionCompetitionSelection.sport);
    //   }
    // }
  }

  ngOnInit(): void {
    this.pageType = ViewConfigurations.useSoonViewWhenTimeFilterIsChanged ? (this.queryParams.pageType ? this.queryParams.pageType : PageType.Soon) :  PageType.Prematch;
    this.favoriteCompetitions = this.storage.favoriteCompetitions.map(c => {
      c.eventsCount = 0;
      return c;
    });
    if (this.utilityService.mobileView) {
      this.dateToStringFormat = { weekday: 'short', month: '2-digit', day: '2-digit' };
    }
    this.queryParams.pageTypeChanged$.subscribe(pageType => {
      this.pageType = pageType;
      if (this.pageType === PageType.Live) {
        this.isLive = true;
      } else {
        this.isLive = false;
      }
    });
    this.getSportsTree(true);
    this.getOddSheets();
    // this.myLeaguesTitle = DynamicTranslations.favoriteButtonName;
  }

  getOddSheets(){
    this.sportsService.getOddSheets().subscribe(x => {
      this.oddSheets = x;
    });
  }

  downloadList(fileName: string, isMainList: boolean){
    this.sportsService.downloadListPdf(fileName, isMainList);
  }

  // setDynamicTranslations(){
  //   this.myLeaguesTitle = DynamicTranslations.favoriteButtonName;
  //   this.eventOfDayShortcut = DynamicTranslations.specialOfferEventsShorcutEventOfDay;
  //   this.superBetShortcut = DynamicTranslations.specialOfferEventsShorcutSuperBet;
  // }

  getSportsTree(forceGetFromServer: boolean = false) {
    // this.getSpecialOfferButtons();
    this.loaderService.showHideLoader(true);
    this.sportsService.getPMSportsTreeForFilterCache(forceGetFromServer).subscribe(sports => {
      // this.setDynamicTranslations();
      // set here because on init is executed before translations response is returned after init

      // this.cacheChanges.removeSportsSubscribtion(false);
      // this.cacheChanges.addSportsSubscribtion(sports.map(s =>  s.id).filter(sid => sid > 0), false);

      this.favoriteCompetitionsHaveOnlineEvents = false;
      for (let index = 0; index < this.favoriteCompetitions.length; index++) {
        const favCmp = this.favoriteCompetitions[index];
        favCmp.isShown = false;
        const sport = sports.find(s => s.id === favCmp.sportId);
        if (sport) {
          const region = sport.regions.find(r => r.id === favCmp.regionId);
          const competition = region ? region.competitions.find(c => c.id === favCmp.id) : null;
          if (competition) {
            competition.isInFavorites = true;
            this.favoriteCompetitions[index] = competition;
            if (competition.eventsCount > 0) {
              this.favoriteCompetitionsHaveOnlineEvents = true;
            }
          }
        }
      }

      this.srcSelectionIds = this.sportsService.getSportRegionCompetitionSelectionIds(this.isLive);
      this.sports = sports;
      // const outrightsId = this.utilityService.getSpecialOfferSportId(SpecialOfferType.Outrights);
      // // dont show outrights for cro
      // if (this.viewConfigurations.showOutrights === false && sports.find(sport => sport.id === outrightsId)){
      //   const index = this.sports.findIndex(sport => sport.id === outrightsId);
      //   this.sports.splice(index, 1);
      // }

      // dont select anything on cro if soon is selected
      if (ViewConfigurations.useSoonViewWhenTimeFilterIsChanged && this.pageType === PageType.Soon) {
        this.sportsService.notifySportsTreeIsLoaded();
        this.loaderService.showHideLoader(false);
        return;
      }

      this.initialLoad = false;
      if (this.pageType === PageType.Prematch) {
        if (!this.srcSelectionIds.sId || !this.srcSelectionIds.rId) {
          if (!this.isMobileView) {
            this.selectMostPopularOrNextMatches(false);
            // when first sport  needs to be selected
            // this.selectFirstSport(sports);
          } else {
            this.showNoEventsForSportMessage = false;
            if (this.srcSelectionIds.sId) {
              if (sports.findIndex(s => s.id === this.srcSelectionIds.sId) < 0) {
                this.showNoEventsForSportMessage = true;
              }
            }
          }
        } else {
          const sport = sports.find(s => s.id === this.srcSelectionIds.sId);
          if (sport && sport.eventsCount < 1) {
            if (this.isMobileView) {
              this.deselectSports();
              this.sportsService.selectSportNotify(null, this.isLive, ComponentName.SportTreeComponent);
            }else{
              this.selectMostPopularOrNextMatches(false);
            }

            this.sendNoEventsNotification(DynamicTranslations.notification_noEventsInSport);

          }else{
            if (sport) {
              if (!sport.specialOfferType) {
                this.selectRegionOnSportTreeInit(sport, this.srcSelectionIds);
              } else {
                this.sportsService.getSpecialOfferSports(sport.specialOfferType, LocaleHelper.cultureName[this.language], this.dateToStringFormat).subscribe(specialOfferSports => {
                  sport.regions = specialOfferSports;
                  this.selectRegionOnSportTreeInit(sport, this.srcSelectionIds);
                });
              }
            } else {
              if (!this.isMobileView) {
                this.selectMostPopularOrNextMatches(false);
                // this.selectFirstSport(this.sports);
              } else {
                this.deselectSports();
                this.sportsService.selectSportNotify(null, this.isLive, ComponentName.SportTreeComponent);
              }
            }
          }
        }
      }
      this.loaderService.showHideLoader(false);
    });
  }

  toggleFavoriteCompetitions() {
    this.favoriteLeaguesIsExpanded = !this.favoriteLeaguesIsExpanded;
    if (this.favoriteLeaguesIsExpanded) {
      const cmpToSelect: ICompetition = this.favoriteCompetitions.find(c => c.eventsCount > 0);
      if (cmpToSelect) {
        this.selectCompetitionFromFavorites(cmpToSelect);
      }
    }
  }

  selectCompetitionFromFavorites(competition: ICompetition) {
    const sport: ISport = this.sports.find(s => s.id === competition.sportId);
    if (!sport) {
      return;
    }
    const region: IRegion = sport.regions.find(r => r.id === competition.regionId);
    if (!region) {
      return;
    }
    const competitionToSelect: ICompetition = region.competitions.find(c => c.id === competition.id);
    if (!competitionToSelect) {
      return;
    }

    this.selectCompetition(competitionToSelect, sport, region);
  }

  sendNoEventsNotification(message: string) {
    const error: ICustomNotification = {
      title: DynamicTranslations.notification_title,
      message,
      errorLevel: ErrorLevel.Notification,
    } as ICustomNotification;
    this.notificationService.forwardDataToNotification(error);
  }

  selectRegionOnSportTreeInit(sport: ISport, srcSelectionIds: ISrcSelectionIds) {
    let region = sport.regions.find(r => r.id === srcSelectionIds.rId);
    if (region && region.eventsCount < 1) {
      if (!sport.specialOfferType) {
        this.sendNoEventsNotification(DynamicTranslations.notification_noEventsInRegion);
        if (this.isMobileView) {
          this.deselectRegions(sport);
          this.sportsService.selectRegionNotify(null, sport, this.isLive, ComponentName.SportTreeComponent);

          return;
        }
      } else {
        this.sendNoEventsNotification(DynamicTranslations.notification_noEventsInSport);
      }

      region = sport.regions.find(r => r.eventsCount > 0);
    }
    if (region) {
      const competition = region.competitions ? region.competitions.find(c => c.id === srcSelectionIds.cId) : null;
      if (competition) {
        if (competition.eventsCount > 0) {
          if (!competition.isSelected) {
            this.selectCompetition(competition, sport, region);
          }
        } else {
          this.sendNoEventsNotification(DynamicTranslations.notification_noEventsInCompetition);
          this.selectCompetition(region.competitions.find(c => c.eventsCount > 0), sport, region);
        }
      }
      else {
        // if (!this.isMobileView) {
        if (region.competitions?.findIndex(c => c.eventsCount > 0) < 0) {
          region.showCompetitions = false;

        }
        if (!region.isSelected) {
          this.selectRegion(region, sport, sport.specialOfferType ? false : true);
        }
        // }
      }
    } else {
      if (!this.isMobileView) {
        if (!sport.isSelected) {
          this.selectSport(sport);
        }
      }
      // this.selectRegion(sport.regions[0]);
    }

  }

  // public selectSport(sport: ISport, isLive: boolean, selectFirstRegion: boolean = true) {
  //   if (sport.isSelected) {
  //     return;
  //   }
  //   sport.isSelected = true;
  //   this.sportsService.clearSelectionsForSelectedSport();
  //   this.srcSelection.sport = sport;
  //   this.srcSelectionIds.sId = sport.id;

  //   if (selectFirstRegion && sport.regions.length > 0) {
  //     this.selectRegion(sport.regions[0]);
  //   }
  //   sessionStorage.setItem('srcSelectionIds', JSON.stringify(this.srcSelectionToSrcSelectionIds()));
  //   this.srcSelectionChangedSource.next(SelectionChangeType.Sport);
  // }

  // public selectRegion(region: IRegion, selectFirstCompetition: boolean = true) {
  //   if (region.isSelected) {
  //     return;
  //   }
  //   region.isSelected = true;
  //   this.sportsService.clearSelectionsForSelectedRegion();
  //   this.srcSelection.region = region;
  //   if (selectFirstCompetition && region.competitions.length > 0) {
  //     this.selectCompetition(region.competitions[0]);
  //   }
  //   sessionStorage.setItem('srcSelectionIds', JSON.stringify(this.srcSelectionToSrcSelectionIds()));
  //   this.srcSelectionChangedSource.next(SelectionChangeType.Region);
  // }

  //
  // public selectCompetition(competition: ICompetition) {
  //   if (competition.isSelected) {
  //     return;
  //   }
  //   competition.isSelected = true;
  //   this.sportsService.clearSelectionsForSelectedCompetition();
  //   this.srcSelection.competition = competition;
  //   sessionStorage.setItem('srcSelectionIds', JSON.stringify(this.srcSelectionToSrcSelectionIds()));
  //   this.srcSelectionChangedSource.next(SelectionChangeType.Competition);

  // }

  selectFromSelectionsChange() {

  }

  getSportName(sportId: number) {
    return this.utilityService.getSportIcon(sportId);
  }

  public selectFirstSport(sports: ISport[]) {
    const sport = sports[0];
    if (sport) {
      this.selectSport(sport);
    } else {
      this.sportsService.selectSportNotify(null, this.isLive, ComponentName.SportTreeComponent);
    }
  }

  selectSport(sport: ISport, event = null, selectToTreeBottom: boolean = true): void {
    if (sport.isSelected) {
      if (!sport.specialOfferType) {
        sport.showRegions = !sport.showRegions;
      }
      return;
    } else {
      this.deselectSports();
      sport.isSelected = true;
      if (!sport.specialOfferType) {
        sport.showRegions = true;
      }

      if (event !== null) {
        // scroll top
        window.parent.scroll(0, 0);
        const li = event.target.closest('li');
        const nodes = Array.from( li.closest('ul').children );
        const index = nodes.indexOf( li );
        const s = li.offsetTop;

        // const index = event.currentTarget.parentElement.attributes['data-index'].value;
        console.log(index);
        // window.parent.scroll(0, 0);
        const parentWindowHeight = window.parent.innerHeight;
        window.parent.document.documentElement.style.scrollBehavior = 'smooth';
        setTimeout(() => {
          const heightFromTop = li.offsetTop;
          const heightFromTop1 = $('.sport-tree ul li:eq(' + index + ')').offset().top;
          console.log('heightFromTop ', heightFromTop);
          // const maxScroll = document.body.clientHeight - window.parent.innerHeight + platformHeaderHeight;
          // if (heightFromTop > maxScroll) {
          //   window.parent.scroll(0, maxScroll);
          // }

          // const aaa = li.clientHeight;
          const extraMove = 100; // 60 - mobileMenu, 40 - not to be right at the bottom
          if (heightFromTop1 + extraMove > parentWindowHeight) {
            const scroll = heightFromTop1 + li.clientHeight + extraMove - parentWindowHeight;
            console.log('scroll ', scroll);
            if (scroll > heightFromTop1) {
              window.parent.scroll(0, heightFromTop1);
              console.log('HFT');
            } else {
              console.log('SCROLL');
              window.parent.scroll(0, scroll);
            }
          }
        }, 10);

      }

    }

    this.queryParams.pageType = this.isLive ? PageType.Live : PageType.Prematch;

    if (!sport.specialOfferType) {
      if (selectToTreeBottom && sport.regions.length > 0) {
        this.selectRegion(sport.regions[0], sport);
      }
      if (!selectToTreeBottom) {
        this.sportsService.selectSportNotify(sport, this.isLive, ComponentName.SportTreeComponent);
      }
    } else {
      this.sportsService.getSpecialOfferSports(sport.specialOfferType, LocaleHelper.cultureName[this.language], this.dateToStringFormat).subscribe(specialOfferSports => {
        sport.regions = specialOfferSports;
        if (selectToTreeBottom && sport.regions.length > 0) {
          this.selectRegion(sport.regions[0], sport, false);
        }
      });
    }
  }

  selectRegion(region: IRegion, sport: ISport, selectToTreeBottom: boolean = true): void {
    if (region.id === -9999) {
      this.selectHiglightedCompetition(sport);
      return;
    }
    if (region.isSelected) {
      // commented out for cro site
      // region.isSelected = false;
      region.showCompetitions = !region.showCompetitions;
      return;
    } else {
      this.deselectRegions(sport);
      region.isSelected = true;
      region.showCompetitions = true;

      setTimeout(() => {
        window.parent.scroll(0, window.parent.scrollY - 1);

        // setTimeout(() => {
        //   window.parent.scroll(0, window.parent.scrollY - 1);
        // }, 150);
      }, 50);

    }

    if (ViewConfigurations.useSoonViewWhenTimeFilterIsChanged) {
      this.queryParams.pageType = this.isLive ? PageType.Live : PageType.Prematch;
    }

    sport.isSelected = true;

    if (selectToTreeBottom && !sport.specialOfferType && region.competitions.length > 0 && !ViewConfigurations.showAllEventsButtonOnSelectedRegion) {
      this.selectCompetition(region.competitions[0], sport, region);
    }

    if (!selectToTreeBottom || ViewConfigurations.showAllEventsButtonOnSelectedRegion) {
      this.sportsService.selectRegionNotify(region, sport, this.isLive, ComponentName.SportTreeComponent);
    }

  }

  selectHiglightedCompetition(sport: ISport) {
    let regionToSelect: IRegion;
    let competitionToSelect: ICompetition;

    for (const region of sport.regions) {
      competitionToSelect = region.competitions.find(c => c.id === environment.higlightedLeagueId);
      if (competitionToSelect) {
        regionToSelect = region;
        break;
      }
    }

    if (regionToSelect && competitionToSelect) {
      this.selectCompetition(competitionToSelect, sport, regionToSelect);
    }
  }

  selectCompetition(competition: ICompetition, sport: ISport, region: IRegion): void {
    if (competition.isSelected) {
      competition.isExpanded = false;
      if (this.isMobileView) {
        competition.isSelected = false;
      }
      return;
    }
    if (competition.isInFavorites) {
      this.deselectSports();
    } else {
      this.deselectCompetitions(region);
    }
    competition.isSelected = true;

    if (!ViewConfigurations.showCompetitionsInSportTree) {
      region.isSelected = true;
    } else {
      region.isSelected = false;
      region.showCompetitions = true;
    }

    sport.isSelected = true;
    sport.showRegions = true;

    if (ViewConfigurations.useSoonViewWhenTimeFilterIsChanged) {
      this.queryParams.pageType = this.isLive ? PageType.Live : PageType.Prematch;
    }

    this.sportsService.selectCompetitionNotify(competition, region, sport, this.isLive, ComponentName.SportTreeComponent);
  }

  deselectSports() {
    for (const sport of this.sports) {
      sport.isSelected = false;
      sport.showRegions = false;
      this.deselectRegions(sport);
    }
  }

  deselectRegions(sport: ISport) {
    for (const region of sport.regions) {
      region.isSelected = false;
      region.showCompetitions = false;
      if (!sport.specialOfferType) {
        this.deselectCompetitions(region);
      }
    }
  }

  deselectCompetitions(region: IRegion) {
    for (const competition of region.competitions) {
      competition.isSelected = false;
    }
  }

  addRemoveCompetitionToFavorites(competition: ICompetition) {
    const favCompetitionInd = this.favoriteCompetitions.findIndex(c => c.id === competition.id);
    if (competition.isInFavorites) {
      competition.isInFavorites = false;
      if (favCompetitionInd < 0) {
        return;
      }

      this.favoriteCompetitions.splice(favCompetitionInd, 1);
      if (this.favoriteCompetitions.findIndex(c => c.eventsCount > 0) < 0) {
        this.favoriteCompetitionsHaveOnlineEvents = false;
      }
      this.storage.favoriteCompetitions = this.favoriteCompetitions;
    } else {

      if (favCompetitionInd < 0) {
        this.favoriteCompetitions.push(competition);
      }
      if (competition.eventsCount > 0) {
        this.favoriteCompetitionsHaveOnlineEvents = true;
      }
      this.storage.favoriteCompetitions = this.favoriteCompetitions;
      competition.isInFavorites = true;
    }
  }

  identify(index: any, item: any) { return item.id; }

  ngOnChanges(): void {
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.cacheChanges.removeSportsSubscribtion(false);
  }
}
